export default "__VITE_ASSET__BDYRDSa9__"